import React from "react";
import { HeaderCaption, Space, Title, Subtitle, Main, CardSection, Container, CardTitle, CardTitleColor, CardFooter, CardHeader } from "./CardStyles";
import Notice from '../../OnBoard/Notice';
import smiOne_logo from '../../../assets/smi-kudzu-images/smi_kudzu_logo.png'
import { useSelector } from "react-redux";
const Card = (props) => {
  const { CardRadius, isForMobile, isLogo, HeaderRadius, cardBg,footerClass, isHeaderCaption, heading, isHome, subheading, isActive, CardSectionRadius, Cardcaption, Cardsubcaption, children, header, HeaderContent, footer, cardHeight, footerContent, cardWidth, HeaderRightRadius, isPerk, isProfile, isWhite, backgroundColor, isShowNotice, isDark, isDarkForKudzu,isWhiteForSignup,isCustomBar } = props
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  return (
    <>
      <div className="sm:block hidden">
        <HeaderCaption isHeaderCaption={isHeaderCaption}>
          <Title isprimary>
            {heading}
            <Subtitle>{subheading}</Subtitle>
          </Title>
        </HeaderCaption>
      </div>
      {
        !isLogo ? <Space></Space> : ""
      }
      

      <Main isHome={isHome}>
        <CardSection style={{ height: cardHeight != null ? cardHeight : '800px', backgroundColor: cardBg ? "#324261" : "" }}
          CardRadius={CardRadius} isPerk={isPerk} isProfile={isProfile}
          isWhite={isWhite} isDark={isDark} isDarkForKudzu={isDarkForKudzu}
          isWhiteForSignup={isWhiteForSignup} isCustomBar={isCustomBar}
          >
          <CardHeader ishidden={header} backgroundColor={backgroundColor} HeaderRadius={HeaderRadius} isActive={isActive}  >
            {HeaderContent}
          </CardHeader>
          <Container style={{ width: cardWidth }}>

            <div className="sm:hidden flex justify-center">
              <HeaderCaption isHeaderCaption={isHeaderCaption}>
                <Title isprimary>
                  {heading}
                  <Subtitle>{subheading}</Subtitle>
                </Title>
              </HeaderCaption>
            </div>

            <div className={`  ${isForMobile ? '' :'sm:block hidden'}`}>
              <CardTitle CardTitleColor isPrimary>
                {
                  (isLogo != undefined && isLogo) &&  <img src={ isFromSmiOne ? smiOne_logo : ""}
                  className={` ${  isFromSmiOne ? ' h-[55.43px]  md:mb-[47px]' : ''}  mb-[35px] md:mb-[51px]`} alt="Modal Logo" />
                }
                 
                {Cardcaption}
              </CardTitle>
            </div>
            {children}
          </Container>
          <CardFooter className={footerClass ? "mb-10" : ""} ishidden={footer} {...(props?.footerBgDisabled ? {} : { backgroundColor: backgroundColor })}>
            {footerContent}
          </CardFooter>
        </CardSection>
        <div className="sm:hidden">
          {(isShowNotice !== undefined && isShowNotice == true) && <Notice />}
        </div>
      </Main>
    </>
  );
};

export default Card;
